export var UniversParameterRead;
(function (UniversParameterRead) {
    let type;
    (function (type) {
        type["DEFAULT"] = "default";
        type["NETWORK"] = "network";
        type["POSITION"] = "position";
        type["FOOTFALL"] = "footfall";
    })(type = UniversParameterRead.type || (UniversParameterRead.type = {}));
})(UniversParameterRead || (UniversParameterRead = {}));
